import { useAuthToggles } from "./useAuthToggles";

export const useNewDesign = authUrl => {
  const { data, isLoading } = useAuthToggles(authUrl);

  return {
    isNewDesignActive: data?.t001_use_new_home_design ?? false,
    isLoading
  };
};
